module.exports = __webpack_public_path__ + "static/fps-c260bc795cddca5e02d4c142c7fd1e25.png";